export default __webpack_public_path__ + "static/media/template.0255f325.csv";